module.exports = __webpack_public_path__ + "fonts/icons.e9bd2d5.ttf";